import { render, staticRenderFns } from "./FormTriaseEdit.vue?vue&type=template&id=5b7d4270&"
import script from "./FormTriaseEdit.vue?vue&type=script&lang=js&"
export * from "./FormTriaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports